import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {MiaChatBackend} from '../../../../../src/app/mia-v3/mia-chat-backend';
import {TelaTesteMiaV3Component} from '../../../../../src/app/mia-v3/tela-teste-mia-v3.component';

/**
 * Backend público do chat: mesmas rotas do simulador do painel, servidas em
 * /widget-mia/<token>/simulador/* (a empresa vem do subdomínio; o token gateia).
 */
class WidgetMiaBackend implements MiaChatBackend {
  constructor(private http: HttpClient, private base: string) {}

  envieTurnoSimulador(
    telefone: string,
    mensagem: string,
    _simularPedidoAberto?: boolean,
    imagem?: {base64: string; mimeType: string; legenda?: string}
  ): Promise<any> {
    const mensagens: any[] = imagem
      ? [{tipo: 'imagem', base64: imagem.base64, mimeType: imagem.mimeType, legenda: imagem.legenda}]
      : [mensagem];
    return this.http.post(`${this.base}/simulador/turno`, {telefone, mensagens}).toPromise();
  }

  obtenhaOpcoesCheckout(): Promise<any> {
    return this.http.get(`${this.base}/simulador/checkout/opcoes`).toPromise();
  }

  envieEventoCheckout(telefone: string, evento: any): Promise<any> {
    return this.http.post(`${this.base}/simulador/checkout/evento`, {telefone, evento}).toPromise();
  }

  envieLocalizacaoCheckout(telefone: string): Promise<any> {
    return this.http.post(`${this.base}/simulador/checkout/localizacao`, {telefone}).toPromise();
  }

  confirmeCheckout(dados: {telefone: string; formaDePagamentoId: number; trocoPara?: number}): Promise<any> {
    return this.http.post(`${this.base}/simulador/checkout/confirmar`, dados).toPromise();
  }
}

/**
 * Página pública do widget de demonstração da Mia (/mia/t/<token>): casca
 * mobile-first com a marca da loja + o MESMO chat da tela de teste do painel.
 */
@Component({
  selector: 'app-widget-mia-pagina',
  templateUrl: './widget-mia-pagina.component.html',
  styleUrls: ['./widget-mia-pagina.component.scss']
})
export class WidgetMiaPaginaComponent implements OnInit {
  @ViewChild(TelaTesteMiaV3Component) chat: TelaTesteMiaV3Component;

  carregando = true;
  invalido = false;
  info: {nome: string; logo: string | null; nomeBot: string; sugestoes?: string[]} | null = null;
  backend: WidgetMiaBackend | null = null;

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token') || '';
    const base = `/widget-mia/${encodeURIComponent(token)}`;

    this.http.get(`${base}/info`).toPromise()
      .then((info: any) => {
        this.info = info;
        this.backend = new WidgetMiaBackend(this.http, base);
        this.carregando = false;
      })
      .catch(() => {
        this.invalido = true;
        this.carregando = false;
      });
  }

  novaConversa() {
    this.chat?.novaConversa();
  }
}
